import { useMemo } from 'react';
import * as Location from 'expo-location';

import { fromPromise } from 'xstate5';

import type { LocationPermissionStatus } from '../../permissions.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const useGetLocationPermissionStatusActor = () => {
  return useMemo(
    () =>
      fromPromise<LocationPermissionStatus>(async () => Location.getForegroundPermissionsAsync()),
    [],
  );
};
